<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
          :disabled="lstRespuestas.length < 2"
        >
          <v-icon>
            mdi-sort
          </v-icon>
          Ordenar respuestas
        </v-btn>
      </template>
      <span>Ordenar respuestas</span>
    </v-tooltip>

    <v-dialog
      name="dialog_ordenar_respuestas"
      key="dialog_ordenar_respuestas"
      v-model="dialog"
      width="700"
      max-width="700"
      scrollable
      transition="scale-transition" origin="center center"
    >
      <v-card>
        <v-card-title class="text-h5 blue darken-4 lighten-2">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="h5" style="color:white!important;">
                <v-icon color="white">mdi-sort</v-icon>
                Ordenar Respuestas
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="px-0">
          <v-row class="mx-0 mt-2">
            <v-col v-if="loading" class="text-center" cols="12">
              <v-skeleton-loader type="image" />
            </v-col>
            <v-col v-else cols="12" class="px-0">

              <v-list two-line subheader>
                <draggable 
                  :list="lstRespuestasNew" 
                  v-bind="dragOptions"
                  @start="drag = true"
                  @end="drag = false"
                  handle=".handle" 
                >
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <v-list-item
                      v-for="(item, idx) in lstRespuestasNew"
                      :key="item.respuesta"
                      @click=""
                    >
                      <v-list-item-avatar>
                        <v-icon
                          class="blue darken-4 white--text handle"
                        >mdi-drag</v-icon>
                      </v-list-item-avatar>
              
                      <v-list-item-content>
                        <v-list-item-title v-text="item.respuesta"></v-list-item-title>
                      </v-list-item-content>
              
                      <v-list-item-action>
                        <v-btn v-if="item != lstRespuestasNew[0]" icon @click="arrayMove(idx, idx-1)">
                          <v-icon color="grey lighten-1">mdi-chevron-up</v-icon>
                        </v-btn>
                        <v-btn v-if="item != lstRespuestasNew.slice(-1)[0]" icon @click="arrayMove(idx, idx+1)">
                          <v-icon color="grey lighten-1">mdi-chevron-down</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>                
                  </transition-group>
                </draggable>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            color="default"
            :loading="loadingSave"
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="mx-2"
            color="success"
            :loading="loadingSave"
            @click="guardar"
          >
          <v-icon class="mr-2">mdi-floppy</v-icon>
            guardar Cambios
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      name="snackbar_dialog_ordenar_respuestas"
      key="snackbar_dialog_ordenar_respuestas"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { putRespuestasOrden } from "@/api";

export default {
  name: "DialogOrdenarRespuestas",
  components: {
  },
  props: {
    lstRespuestas: {
      type: Array,
      default: function () {
        return []
      }
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingSave: false,

      drag: false,

      lstRespuestasNew: [],      

      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch:{
    dialog: {
      handler (newValue, oldValue) {
        if(newValue == true){
          this.loading = true;
          Array.prototype.push.apply(this.lstRespuestasNew, this.lstRespuestas);
          this.loading = false;
        }
        else{
          this.lstRespuestasNew = [];          
        }
			},
    }
  },
  beforeMount(){
  },
  mounted() {
  },
  methods: {
    arrayMove(fromIndex, toIndex) {
      var element = this.lstRespuestasNew[fromIndex];
      this.lstRespuestasNew.splice(fromIndex, 1);
      this.lstRespuestasNew.splice(toIndex, 0, element);
    },
    async guardar(){
      var self = this;

      self.loadingSave = true;
      self.snackbar = false;
      self.snackbarTexto = "";
      self.snackbarColor = "";
          
      try {

        this.lstRespuestasNew.forEach(function(item, index){
          item.orden = index+1;
        });

        let response = await putRespuestasOrden(this.lstRespuestasNew);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Guardado correcto") {
              self.snackbarTexto = "Respuestas guardadas con éxito";
              self.snackbarColor = "success";
              self.snackbar = true;

              self.fnOnSave();

              self.dialog = false;
            }
          } else {
            self.snackbarTexto = "DialogOrdenarRespuestas: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.snackbarTexto = "DialogOrdenarRespuestas: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingSave = false;
      } catch (e) {
        self.loadingSave = false;
        self.snackbarTexto = "DialogOrdenarRespuestas: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
  },  
};
</script>

<style scoped>
.handle {
  cursor: move !important; /* fallback if grab cursor is unsupported */
  cursor: grab !important;
  cursor: -moz-grab !important;
  cursor: -webkit-grab !important;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.handle:active, ui-widget-content:active, ui-draggable:active, ui-draggable-handle:active, .draggable2.ui-draggable-dragging {
  cursor: grabbing !important;
  cursor: -moz-grabbing !important;
  cursor: -webkit-grabbing !important;
}
</style>